<template>
  <v-row v-if="rstVisible" no-gutters>
    <v-col :cols="embed ? 12 : 8" :offset="embed ? 0 : 4" class="pa-0">
      <div :style="embed?'':'width:480px;padding-left:40px;'">
        <mini-textarea-editor style="height:80px;" :id="`${chartElId}-numberClickRst`" placeholder="请点击数字以显示相同项"></mini-textarea-editor>
      </div>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: ['chart-el-id','embed', 'rst-visible']
}
</script>